import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/Ecommerce_Chatbot_Demo_Instagram_.png")